import React, { useState } from 'react';
import styles from './WeatherWidget.module.css';
import { 
  IconCloudSnow, 
  IconTemperature, 
  IconWind, 
  IconDroplet, 
  IconCloudStorm
} from '@tabler/icons-react';

const WeatherWidget = () => {
  const [activeTab, setActiveTab] = useState('In Progress');
  
  // Sample data for weather forecast
  const forecastTabs = ['In Progress', 'Within 24h', 'Within 48h', 'Within 72h'];
  
  const weatherData = [
    { location: 'Mississauga', temp: '-7°C', wind: '30km/h', precipitation: '50%', condition: 'Heavy Storm' },
    { location: 'Mississauga', temp: '-7°C', wind: '30km/h', precipitation: '50%', condition: 'Heavy Storm' },
    { location: 'Mississauga', temp: '-7°C', wind: '30km/h', precipitation: '50%', condition: 'Heavy Storm' },
    { location: 'Mississauga', temp: '-7°C', wind: '30km/h', precipitation: '50%', condition: 'Heavy Storm' },
    { location: 'Mississauga', temp: '-7°C', wind: '30km/h', precipitation: '50%', condition: 'Heavy Storm' }
  ];

  const upcomingStorms = [
    {
      location: 'Toronto',
      stormType: 'Snow Storm in 3 h',
      details: [
        { label: 'Duration', value: '2 h', emoji: '🕒' },
        { label: 'Heavy snow', value: '15-20 cm', emoji: '❄️' },
        { label: 'Strong winds', value: '30-50 mph', emoji: '💨' },
        { label: 'Visibility', value: 'Low', emoji: '🌫️' },
        { label: 'Severity', value: 'High', emoji: '⚠️' }
      ]
    },
    {
      location: 'Toronto',
      stormType: 'Snow Storm in 3 h',
      details: [
        { label: 'Duration', value: '2 h', emoji: '🕒' },
        { label: 'Heavy snow', value: '15-20 cm', emoji: '❄️' },
        { label: 'Strong winds', value: '30-50 mph', emoji: '💨' },
        { label: 'Visibility', value: 'Low', emoji: '🌫️' },
        { label: 'Severity', value: 'High', emoji: '⚠️' }
      ]
    },
    {
      location: 'Toronto',
      stormType: 'Snow Storm in 3 h',
      details: [
        { label: 'Duration', value: '2 h', emoji: '🕒' },
        { label: 'Heavy snow', value: '15-20 cm', emoji: '❄️' },
        { label: 'Strong winds', value: '30-50 mph', emoji: '💨' },
        { label: 'Visibility', value: 'Low', emoji: '🌫️' },
        { label: 'Severity', value: 'High', emoji: '⚠️' }
      ]
    }
  ];

  return (
    <div className={styles.weatherWidget}>
      <div className={styles.header}>
        <h2>Weather Forecast</h2>
        <span className={styles.lastUpdated}>Last updated 3 minutes ago</span>
      </div>

      <div className={styles.tabList}>
        {forecastTabs.map((tab) => (
          <button 
            key={tab} 
            className={`${styles.tabButton} ${activeTab === tab ? styles.activeTab : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className={styles.forecastList}>
        {weatherData.map((item, index) => (
          <div key={index} className={styles.forecastItem}>
            <div className={styles.forecastLocation}>
              {item.location}
            </div>
            
            <div className={styles.forecastTemperature}>
              <span className={styles.temperatureLabel}>t</span>
              <span className={styles.temperatureValue}>{item.temp}</span>
            </div>
            
            <div className={styles.forecastWind}>
              <IconWind size={16} className={styles.windIcon} />
              <span>{item.wind}</span>
            </div>
            
            <div className={styles.forecastPrecipitation}>
              <IconDroplet size={16} className={styles.precipitationIcon} />
              <span>{item.precipitation}</span>
            </div>
            
            <div className={styles.forecastCondition}>
              <IconCloudStorm size={16} className={styles.conditionIcon} />
              <span>{item.condition}</span>
            </div>
          </div>
        ))}
      </div>

      <h3 className={styles.sectionTitle}>Upcoming Storms</h3>

      <div className={styles.stormCardContainer}>
        {upcomingStorms.map((storm, index) => (
          <div key={index} className={styles.stormCard}>
            <div className={styles.stormIcon}>
              <IconCloudSnow size={20} />
            </div>
            
            <div className={styles.stormHeaderContent}>
              <h4>{storm.location}</h4>
              <p className={styles.stormType}>{storm.stormType}</p>
            </div>
            
            <div className={styles.stormDivider}></div>
            
            <div className={styles.stormDetails}>
              {storm.details.map((detail, idx) => (
                <div key={idx} className={styles.stormDetailItem}>
                  <span className={styles.detailEmoji}>{detail.emoji}</span>
                  <div className={styles.detailText}>
                    <span className={styles.detailLabel}>{detail.label}: </span>
                    <span className={styles.detailValue}>{detail.value}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeatherWidget;
